import React, { Component } from "react";
import { Form, Validators } from "../../components/form/DynamicFormTs";
import { withRouter } from "react-router-dom";
import { DynamicForm } from "../../components/form/DynamicForm";
import {
   Button,
   CircularProgress,
} from "@material-ui/core";
import ACCESS from "../../ACCESS";
import { AuthContext } from "../../context/authContext";
import Toast from "react-hot-toast";
import Http from "../../Http";

const CONCEPTOS = [
   { 'Value': 1, 'Label': 'Normal' },
   { 'Value': 2, 'Label': 'Nocturna' },
   { 'Value': 4, 'Label': 'Autoservicio Normal' },
   { 'Value': 5, 'Label': 'Autoservicio Nocturno' },
   { 'Value': 6, 'Label': 'Autoservicio Dias Festivos' },
   { 'Value': 7, 'Label': 'Complemento EAD' },
];

class EditEAD extends Component {
   idEAD = isNaN(this.props.match.params.id) ? null : this.props.match.params.id;
   is_create = !(this.idEAD > 0)

   state = {
      guias: [],
      FormData: new Form(
         [
            Form.Field(this.is_create ? 'hidden' : "text", "id", "Folio EAD", "", [], 6, [], [], [], false, true),
            Form.Field("autocomplete-async", "id_guia", "Guia", "", [Validators.required], 6, [], [], [], false, !this.is_create, '', 'search/guia-ead'),
            Form.Field(this.is_create ? 'hidden' : "date-hour", "createdAt", "Fecha de Creacion", new Date(), [], 12, [], [], [], false, true),
            Form.Field("checkbox", "tiene_cita", "Tiene Cita", true, [Validators.required], !this.is_create ? 12 : 6, [], [], [], false, true),
            Form.Field("date-hour", "fecha_ead", "Fecha Cita EAD", null, [Validators.required], 6),
            Form.Field("select", "concepto", "Detalle de entrega", "", [Validators.required], 6, CONCEPTOS, [], false, [], true),
            Form.Field("textarea", "descripcion", "Descripcion", "", [Validators.required], 12),
         ], [],
         !this.is_create ? `Editar Cita #${this.idEAD}.` : "Nueva Cita"
      ),
      loadingData: true,
      loadingError: '',
      disabled: false,

      saving: false,
   };

   componentDidMount() {
      const { hasAccess } = this.context;
      let disabled = !hasAccess([ACCESS.CITAS_EAD.EDITAR_CITAS_CLIENTE, ACCESS.CITAS_EAD.EDITAR_CITAS_SUCURSAL, 
         ACCESS.CITAS_EAD.EDITAR_CITAS_TODAS, ACCESS.CITAS_EAD.EDITAR_CITAS_USUARIO]);
      if (this.idEAD) {
         this.LoadPreds(this.idEAD).then(d => {
            this.setState({ loadingData: false });
         }).catch(() => {
            this.setState({ loadingError: 'Error al cargar', loadingData: false, disabled });
         })
      } else {
         this.setState({ loadingData: false, disabled });
      }
   }

   componentDidUpdate(prevprops) {
      if (prevprops.match.params.id !== this.props.match.params.id) {
         this.idEAD = isNaN(this.props.match.params.id) ? null : this.props.match.params.id;
         this.is_create = !(this.idEAD > 0);

         if (this.idEAD) {
            this.LoadPreds(this.idEAD).then(d => {
               this.setState({ loadingData: false });
            }).catch(() => {
               this.setState({ loadingError: 'Error al cargar', loadingData: false });
            })
         } else {
            this.setState({ loadingData: false });
         }
      }
   }

   LoadPreds = async (id = null) => {
      let { FormData } = this.state;
      try {
         let Res = await Http.get(`ead/one/${id}`);
         if (!Res.error) {
            let newForm = { ...FormData };
            const is_available = ![2, 3].includes(Res.data.id_status)
            newForm = Form.FieldMod(newForm, 'id', 'Type', this.is_create ? 'hidden' : "text");
            newForm = Form.FieldMod(newForm, 'id_guia', 'Disabled', !this.is_create);
            newForm = Form.FieldMod(newForm, 'id_guia', 'Options', [{ Value: Res.data.id_guia, Label: Res.data.g_folio }]);
            newForm = Form.FieldMod(newForm, 'createdAt', 'Type', this.is_create ? 'hidden' : "date-hour");
            newForm = Form.FieldMod(newForm, 'tiene_cita', 'Col', !this.is_create ? 12 : 6);
            newForm = Form.FieldMod(newForm, 'tiene_cita', 'Disabled', !Res.data.entrega);
            newForm.Title = !this.is_create ? (is_available ? `Editar Cita #${this.idEAD}` : `Cita #${this.idEAD}. Estatus: ${Res.data.status}`) : "Nueva Cita";
            
            this.setState({
               FormData: Form.Patch(newForm, Res.data, true),
               disabled: !is_available
            });
            return Res.data;
         } else {
            this.setState({ loadingError: 'Error al cargar informacion(1)', loadingData: false });
         }
      } catch (error) {
         this.setState({ loadingError: 'Error al cargar informacion(2)', loadingData: false });
      }
      return null;
   }

   onGuiaChange = (field, form) => {
      let guiaInfo = field ? field.Options.find(o => o.Value === field.Value) : {};
      if (guiaInfo && guiaInfo.id_ead) {
         this.props.history.push(`/EAD/Edit/${guiaInfo.id_ead}`);
         return form;
      }
      form = Form.Patch(form, { concepto: guiaInfo.concepto_guia }, false)
      return form;
   }

   formChange = async (form, field, type) => {
      let newForm = { ...form };
      if (field.Name === 'id_guia' && type !== 'options') {
         newForm = this.onGuiaChange(field, newForm)
      }

      this.setState({ FormData: newForm });
   }

   saveCitaEAD = async (e) => {
      const { saving, FormData, disabled } = this.state;
      e.preventDefault();
      if (saving || disabled) return;
      let valid = Form.ValidateForm(FormData);
      if (valid !== true) return Toast.error(`Error en el campo '${valid.name}'`);
      let values = Form.FieldsValues(FormData);
      
      if (values.tiene_cita && !values.fecha_ead) {
         return Toast.error(`Es necesario definir la Fecha y Hora de la cita EAD`);
      }
      
      this.setState({ saving: true });
      const res = Http.post('ead/save', {
         id_ead: this.idEAD,
         id_guia: values.id_guia,
         fecha_ead: values.fecha_ead,
         descripcion: values.descripcion,
         tiene_cita: values.tiene_cita,
         concepto: values.concepto
      });

      res.then(data => {
         if (data.error) return Toast.error(data.errMsg);
         this.idGuia = data.data.id
         Toast.success(`Se ha ${this.is_create ? 'guardado' : 'editado'} correctamente. Folio EAD: #${data.data.id}`);
         if (data.data.id) return this.props.history.push(`/EAD/Edit/${data.data.id}`);
      }).catch((err) => {
         return Toast.error('Error inesperado al guardar la cita (EAD-99)')
      }).finally(() => {
         this.setState({ saving: false });
      });
   }

   render() {
      const {
         FormData,
         loadingData,
         loadingError,
         disabled,
         saving
      } = this.state;
      const { hasAccess } = this.context;

      if (loadingData) {
         return <div style={{ width: '100%', height: 100, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }} >
            <CircularProgress size={"50px"} color="primary" />
            <div><h3>Cargando...</h3></div>
         </div>
      }

      if (loadingError) {
         return <div style={{ width: '100%', height: 100, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }} >
            <h3>{loadingError}</h3>
         </div>
      }

      return (
         <div>
            <DynamicForm
               form={FormData}
               disabled={disabled}
               formChange={this.formChange}
               onSubmit={this.onSubmit}
            />
            <div style={{
               display: 'flex',
               width: '100%',
               justifyContent: 'flex-end',
               padding: 5,
            }} >
               <Button
                  variant='contained'
                  onClick={this.saveCitaEAD}
                  disabled={disabled || saving}
                  color='primary'>
                  {saving && <CircularProgress size={20} style={{ marginRight: 5 }} />}
                  {`Guardar Cita`}
               </Button>
            </div>
         </div>
      );
   }
}

EditEAD.contextType = AuthContext;
export default withRouter(EditEAD);